export const HistoryEventTypeVals = {
    RejectAgreement: 2,
    SendingProjectDocGIPApproval: 8,
    RejectProjectDocGIPApproval: 9,
    StartWorkflowInstance: 10,
    ApprovalProjectDoc: 13,
    CreatedAttachment: 15,
    SentVolume: 17,
    EdiSigningCompleted: 25,
    SentToContractor: 29
};
